<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <designated-form :info="info"></designated-form>
      </div>
    </div>
  </section>
</template>

<script>
import designatedForm from './Temp/designatedForm.vue'
export default {
  components: {
    'designated-form': designatedForm
  },
  data () {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  created () {
    if (this.$route.name === 'upDesignated') this.getDesignated()
  },
  methods: {
    getDesignated () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/designatedUnit/' + this.$route.params.unit_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.unit
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpDesignated.vue?3a966a02